import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import shapes from './shapes';
import Bell from '@ux/icon/bell';

/**
 * Render NotificationBadge component.
 *
 * @class NotificationBadge
 * @public
 *
 * @returns {React.ReactElement} Notification alarm icon
 */

class NotificationBadge extends Component {
  render() {
    const { isOpen, tooltip, messages = {}, unviewedNotifications } = this.props;

    const bellClasses = classnames(
      'btn dropdown-toggle',
      {
        'notifications-bell': true,
        'no-count': unviewedNotifications
      }
    );

    const messagesLabel = tooltip || messages.headerText;

    return (
      <button
        aria-expanded={ isOpen }
        aria-label={ messagesLabel }
        className={ bellClasses }
        title={ tooltip }
        id='notifications-bell'
        type='button'>
        <Bell />
        {unviewedNotifications && (
          <div className='notifications-badge font-primary-bold' />
        )}
      </button>
    );

  }
}

/**
 * Property definitions.
 * @type {Object}
 *
 * @public
 */

NotificationBadge.propTypes = {
  isOpen: PropTypes.bool,
  /** Used as "roll over text" for the notification button */
  tooltip: PropTypes.string,
  /** Notification strings with translations */
  messages: shapes.messages,
  /**  Provides bool where true means there are unviewed notifications. */
  unviewedNotifications: PropTypes.bool
};

export default NotificationBadge;
